import FunctionBarServLock from '@/presentation/pages/detail/basic/interface_lock/FunctionBarServLock';
import { KNOWN_PLUGIN_NAMES } from '@/presentation/pages/detail/basic/constant/basic';
import { router } from '@/routers';
export default class BioFunctionBarService extends FunctionBarServLock {
    toImportData() {
        router.push({
            name: 'resourceImport',
            query: {
                detailRouteName: router.currentRoute.name,
                ...router.currentRoute.query,
                importDataType: KNOWN_PLUGIN_NAMES.BIO,
            },
        });
    }
}
